const ALERT_BOX_VARIANTS = {
  primary: 'primary',
  secondary: 'secondary',
} as const;

type AlertBoxVariant = (typeof ALERT_BOX_VARIANTS)[keyof typeof ALERT_BOX_VARIANTS];

export {ALERT_BOX_VARIANTS};
export type {AlertBoxVariant};
